import React from 'react'
import Confirm from 'views/confirm/confirm'
import { connect } from 'react-redux'
import bindActionsToDispatch from 'helpers/bindActionsToDispatch'

import gameActions from 'redux/actions/gameActions'
import { localize } from 'helpers/translator'

const GameActivityDeleteConfirm = props => (
	<Confirm
		btOne={localize('global_no')}
		btTwo={localize('global_yes')}
		alertMessage={localize('creationTool_question_answerTypeToggleConfirm')}
		actionButtonType={0}
		actionOne={props.actions.changeAnswerTypeCancel}
		actionTwo={() => props.actions.changeAnswerTypeConfirm(props.activityId, props.value, true)}
		closeAction={props.actions.changeAnswerTypeCancel}
	/>
)

function mapDispatchToProps(dispatch) {
	return bindActionsToDispatch({
		changeAnswerTypeCancel: gameActions.selectAnswerTypeCancel,
		changeAnswerTypeConfirm: gameActions.selectAnswerTypeHandler,
	}, dispatch)
}

export default connect(null, mapDispatchToProps)(GameActivityDeleteConfirm)

export { GameActivityDeleteConfirm }
